import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";

type Day = { id: number | string, name: string };


export function ComboBoxGiorni<T extends FieldValues>(props: {
                                                          control: Control<T>, name: FieldPath<T>, defaultValue: any, label?: string,
                                                          data: Day[] | undefined, isLoading?: boolean, onChange?: (v: Day | null) => void,
                                                          disabled?: boolean, divClass?: string
                                                      }
) {
    return <div className={props.divClass ? props.divClass : ''}>
        <Controller name={props.name}
                    control={props.control}
                    defaultValue={props.defaultValue}
                    render={({field: {value, onChange}, fieldState}) => {
                        return (
                            <ComboBox<Day> label={props.label ? props.label : 'Giorno settimana'} value={{id: value}} onChange={(value) => {
                                onChange(value?.id);
                            }}
                                           data={props.data}
                                           isLoading={props.isLoading}
                                           searchablePropsName={["name"]}
                                           disabled={props.disabled}
                                           fieldState={fieldState}
                                           isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                           keyValueFn={(v) => v.id!}
                                           displayValueFn={(v) => props.data && v ? v.name : ''}
                            />
                        )
                    }}
        />
    </div>
}